import * as React from "react";

import { ActionPrimary, SingleLineTextInput } from "../../form";

import {
  OneTimePasswordFormLogic_SendCode,
  useOneTimePasswordSendCodeForm,
  useOneTimePasswordUserExperienceFirstStepSendCode,
} from "../../providers";

import { OneTimePasswordProminentErrorMessageBox } from "../prominent-error-message-box";

export const OneTimePasswordSendCodeFormUi: React.FunctionComponent = (
  props
) => {
  const {
    handleSendCode:
      oneTimePasswordUserExperienceFirstStepSendCode_handleSendCode,
  } = useOneTimePasswordUserExperienceFirstStepSendCode();

  const { form, onFormFieldFocus, onFormInputChange, onFormInputBlur } =
    useOneTimePasswordSendCodeForm();

  const handleSendCode: React.MouseEventHandler<HTMLButtonElement> = (
    event
  ) => {
    event.preventDefault();
    oneTimePasswordUserExperienceFirstStepSendCode_handleSendCode();
  };

  const handleCancelSubmit: React.MouseEventHandler<HTMLFormElement> =
    React.useCallback((event) => {
      event.preventDefault();
    }, []);

  return (
    <form className="one-time-password-send-code" onSubmit={handleCancelSubmit}>
      <SingleLineTextInput
        name="email"
        type="email"
        inputMode="email"
        autoComplete="email"
        form={form}
        onFocus={onFormFieldFocus}
        onChange={onFormInputChange}
        onBlur={onFormInputBlur}
        required={
          OneTimePasswordFormLogic_SendCode.email?.presentation?.required
        }
        displayName={"Account Email Address"}
      />

      <ActionPrimary name="send-code" onClick={handleSendCode}>
        SEND CODE
      </ActionPrimary>

      <OneTimePasswordProminentErrorMessageBox />
    </form>
  );
};
